import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=1b3e67bb&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=js&"
export * from "./BaseCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=1b3e67bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e67bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3e67bb')) {
      api.createRecord('1b3e67bb', component.options)
    } else {
      api.reload('1b3e67bb', component.options)
    }
    module.hot.accept("./BaseCard.vue?vue&type=template&id=1b3e67bb&scoped=true&", function () {
      api.rerender('1b3e67bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/BaseCard.vue"
export default component.exports